import SelectDinamico from "../../SelectDinamico";
import ConsultaFornecedor from "../../../../lib/json/consultas/FornecedorSelect.json"

function SelectFornecedor({campoFornecedor, changeFornecedor, queryFornecedor, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field}){
    const consulta = queryFornecedor || ( loadDefault ? ConsultaFornecedor.consulta + " WHERE A2_FILIAL = FILIAL(SA2) AND SA2.D_E_L_E_T_ <> '*' " : '' )
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const fornecedorValue = bindItem ? bindItem[field] : campoFornecedor;

    return (
        <SelectDinamico
            label="Fornecedor"
            cText="A2_COD.trim() + '/' + item.A2_LOJA.trim() + ' - ' + item.A2_NOME.trim() + '(' + item.A2_CGC.trim() + ')'"
            cValue="A2_COD + '' + item.A2_LOJA"
            campoValue={fornecedorValue}
            consulta={consulta}
            tabela={ConsultaFornecedor.tabelas}
            isMultiplo={false}
            showNoFilter={false}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeFornecedor(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectFornecedor;